module.exports = __webpack_public_path__ + "img/simbg.2bcd9698.png";